import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import TableRowsIcon from '@mui/icons-material/TableRows';
import GridViewIcon from '@mui/icons-material/GridView';

const DEFAULT_OPTIONS = [
  {
    value: 'tiles',
    label: 'Tiles',
    icon: <GridViewIcon fontSize="small" />,
  },
  {
    value: 'rows',
    label: 'Rows',
    icon: <TableRowsIcon fontSize="small" />,
  },
];

const ViewModeToggle = ({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  size = 'small',
  exclusive = true,
  ...props
}) => {
  const handleChange = (event, nextValue) => {
    if (!nextValue) {
      return;
    }
    onChange?.(nextValue);
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive={exclusive}
      size={size}
      onChange={handleChange}
      aria-label="View mode"
      {...props}
    >
      {options.map((option) => (
        <Tooltip key={option.value} title={option.label}>
          <ToggleButton value={option.value} aria-label={option.label}>
            {option.icon}
          </ToggleButton>
        </Tooltip>
      ))}
    </ToggleButtonGroup>
  );
};

export default ViewModeToggle;
